export default function SocialMedia() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A]">Social Media</h1>
        <p className="text-[#6B6B6B] mt-1">
          Verwalte deine Social Media Verknüpfungen
        </p>
      </div>
      <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 p-6 sm:p-8 text-center">
        <p className="text-[#6B6B6B] dark:text-slate-400">
          Social Media Einstellungen findest du in deinem Profil.
        </p>
      </div>
    </div>
  );
}
